import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback, useMemo } from 'react';
import { DefaultConfirmation, } from './confirmation-messages/default-confirmation';
export function useConfirm(onConfirm, onDecline) {
    const [defer, setDefer] = useState(undefined);
    const handler = useCallback(async (...args) => {
        let isConfirmed;
        try {
            isConfirmed = await new Promise((resolve, reject) => {
                setDefer({
                    confirm: () => resolve(true),
                    decline: () => resolve(false),
                    cancel: reject,
                });
            });
        }
        catch (_a) {
            return;
        }
        finally {
            setDefer(undefined);
        }
        if (isConfirmed) {
            onConfirm(...args);
        }
        else if (onDecline) {
            onDecline(...args);
        }
    }, [onConfirm, onDecline]);
    const Confirm = useMemo(() => ({ when = true, confirmation: Confirmation = DefaultConfirmation, ...props }) => {
        if (!defer) {
            return null;
        }
        if (!when) {
            defer.confirm();
            return null;
        }
        return (_jsx(Confirmation, { ...props, onConfirm: defer.confirm, onDecline: defer.decline, onCancel: defer.cancel }));
    }, [defer]);
    return [Confirm, handler];
}
//# sourceMappingURL=use-confirm.js.map